import { Register8 } from '@/Emulator/Utility';

export class StatusRegister extends Register8
{
    public static readonly SPRITE_OVERFLOW_BIT: number = 5;
    public static readonly SPRITE_ZERO_HIT_BIT: number = 6;
    public static readonly V_BLANK_BIT: number         = 7;

    constructor()
    {
        super(new Uint8Array(1), 0);
    }

    public getVBlank(): boolean
    {
        return this.hasBit(StatusRegister.V_BLANK_BIT);
    }

    public setVBlank(): void
    {
        this.setBit(StatusRegister.V_BLANK_BIT, true);
    }

    public clearVBlank(): void
    {
        this.setBit(StatusRegister.V_BLANK_BIT, false);
    }

    public setSpriteZeroHit(): void
    {
        this.setBit(StatusRegister.SPRITE_ZERO_HIT_BIT, true);
    }

    public clearSpriteZeroHit(): void
    {
        this.setBit(StatusRegister.SPRITE_ZERO_HIT_BIT, false);
    }

    public setSpriteOverflowBit(): void
    {
        this.setBit(StatusRegister.SPRITE_OVERFLOW_BIT, true);
    }

    public clearSpriteOverflowBit(): void
    {
        this.setBit(StatusRegister.SPRITE_OVERFLOW_BIT, false);
    }
}
